import { render } from "./DisputeConfirmModal.vue?vue&type=template&id=bc2b2412&ts=true"
import script from "./DisputeConfirmModal.vue?vue&type=script&lang=ts"
export * from "./DisputeConfirmModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__